import { Tax } from '../Taxes/Model';
import PassengerCategory from '../PassengerCategories/Model';
export class StretchPrice {
    constructor(values) {
        Object.assign(this, values);
        this.id = values.id;
        this.price = values.price;
        this.priceNet = values.priceNet;
        this.printPrice = values.printPrice;
        if (values.passengerCategory) {
            this.passengerCategory = new PassengerCategory(values.passengerCategory);
        }
        if (values.tax) {
            this.tax = new Tax(values.tax);
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/StretchPrice.ts
// module id = 155
// module chunks = 0